import FormTrait from 'src/app/traits/form.trait'
import { Profile } from './profile.interface'
import { getProfileState, getUpdatePasswordState } from './profile.selectors'
import {
  FetchProfileRequest,
  SetDefaultData,
  UpdateField,
  UpdatePasswordRequest,
} from './profile.actions'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import Validator from '@shared/validatorjs/src/validator'
import { VersionService, VersionInfo } from 'src/app/services/version.service'

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent extends FormTrait implements OnInit, OnDestroy {
  public profile: Profile
  private profileState$: Subscription
  private state$: Subscription
  public isLoading: boolean
  public isUpdating: boolean
  public versionInfo: VersionInfo

  constructor(
    private store: Store<any>,
    private versionService: VersionService,
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('user'))
    this.state$ = this.store
      .pipe(select(getUpdatePasswordState))
      .subscribe((state) => {
        this.state = state
        this.isUpdating = state.get('isLoading')
      })
    this.profileState$ = this.store
      .pipe(select(getProfileState))
      .subscribe((state) => {
        this.profile = state.get('data').toJS()
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch<any>(new FetchProfileRequest())
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updatePassword.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updatePassword',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      existingPassword: 'required',
      newPassword: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      existingPassword: 'existing password',
      newPassword: 'new password',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdatePasswordRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updatePassword',
        ),
      )
    }
  }

  ngOnDestroy() {
    this.profileState$.unsubscribe()
    this.state$.unsubscribe()
  }
}
